import {AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {SuppliersService} from '../../../../services/suppliers.service';
import {MatDialog} from '@angular/material/dialog';
import {APP_GUIDS, AppGuids} from '../../../../app.guids';
import {FileResponse} from '../../../../models/file.response';
import {saveAs} from 'file-saver';
import {ChangedOverlayComponent} from '../../overlays/changed-overlay/changed.overlay.component';
import {ProjectStatusModel} from '../../project-status/project.status.model';
import {CoreService, DocumentService, Param, ProleisObject} from "@proleis/proleis-rest-client";
import {CurrentViewService, NotificationService} from "@proleis/proleis-web-app";

@Component({
  selector: 'ps-position-tp-card',
  templateUrl: 'position.card.tp.component.html',
  styleUrls: ['position.card.tp.component.scss']
})
export class PositionCardTpComponent implements OnInit, AfterViewInit {
  @Input()
  pos: ProleisObject;

  @Input()
  pbo: ProleisObject;

  test = false;

  changed: boolean;

  @Output()
  checkChangedEvent= new EventEmitter<boolean>();

  constructor(private coreService: CoreService, private notificationService: NotificationService,
              private currentViewService: CurrentViewService, public suppliersService: SuppliersService, private dialog: MatDialog,
              private documentsService: DocumentService, @Inject(APP_GUIDS) private guids: AppGuids) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.changed = this.suppliersService.hasOrderChanged(this.pos);
  }

  insertProjectStatus(id: string) {
    const params: Param[] = [];
    this.coreService.executeAction<ProjectStatusModel>(id, '§b02fe89c-2c51-11b2-8016-cb6d12b1d0f5', params).subscribe(result => {
      this.notificationService.showNotification('Projektstatus angelegt');
    }, error => {
      this.notificationService.showError(error.error);
    });
  }

  openChangedDialog() {
    this.dialog.open(ChangedOverlayComponent, {
      data: {
        docName: this.pos.DWS_CHANGE_DOCUNAME,
        docId: this.pos.DWS_CHANGE_DOCU_ID,
        posId: this.pos.OBJECT_ID
      }
    }).afterClosed().subscribe(result => {
      this.checkChangedEvent.subscribe(true);
    });
  }

  isInternal(): boolean {
    return this.pbo.CHANNELGUID === this.guids.GUID_CHANNEL_INTERNAL;
  }

  downloadDeliveryNote(pos: ProleisObject) {
    return this.documentsService.getDocumentFile(pos.PBO_DELIVERY_DOC_ID).subscribe(response => {
        const fileResponse: FileResponse = FileResponse.parseResponse(response);
        saveAs(fileResponse.content, fileResponse.fileName);
        this.currentViewService.setLoading(false);
      }
    );
  }

  createBmDelivery() {
    this.suppliersService.createBmDelivery(this.pbo, this.pos).subscribe(pos => this.pos = pos);
  }
}
